import { combineReducers } from "redux";
import appSettingReducer from "./appseting.reducer";
import loadingReducer from "./loading.reducer";
import userReducer from "./user.reducer";
import clientReducer from "./client.reducer";
import faqReducer from "./faq.reducer";
import chatHistoryReducer from "./chatHistory.reducer";
import googleAdsReducer from "./googleAds.reducer";

const rootReducer = combineReducers({
  loadingReducer: loadingReducer,
  appSettingReducer: appSettingReducer,
  userReducer: userReducer,
  clientReducer: clientReducer,
  faqReducer: faqReducer,
  chatHistoryReducer: chatHistoryReducer,
  googleAdsReducer: googleAdsReducer,
});

export default rootReducer;